import React, { Component } from 'react';
import { connect } from "react-redux"
import { bool } from "prop-types"

import Icon from "../Icon";
import PageContent from '../PageContent';
import { go } from "../../logic/actions/navigation"
import { LIVENESS_TEST } from '../../logic/enums/pages';

export class PageInstructionsCLR extends Component {
  static propTypes = {
    error: bool
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  render() {
    const btnEnabled = !this.props.error;
    return (
      <PageContent>
        <header>
        </header>
        <h1 style={{ margin: "5px" }}>Extra Checks</h1>
        <p className="center">We are about to perform some extra checks for your security. We simply want to check that it's really you applying. This won't take long!</p>
        <p className="center">On the next screen you will see a sequence of color flashes. Hold your phone in front of your face so that your face fits the oval.</p>
        <div className="panel border-green">
          <div className="column">
            <div className="row">
              <Icon name="Light-indoor" color="gray" />
              <p>Make sure you are in an area without strong lighting, indoors works best</p>
            </div>
            <hr />
            <div className="row">
              <Icon name="Focus-round" color="gray" />
              <p>Hold the camera so your face remains in the oval</p>
            </div>
            <hr />
            <div className="row">
              <Icon name="Tap" color="gray" />
              <p>Tap on start when ready</p>
            </div>
          </div>
        </div>
        {this.props.error ? (<p className="error">An error has occured, please try again and if problem persists contact your support</p>) : null}
        <button disabled={!btnEnabled} className={`btn ${btnEnabled ? "green" : "gray"}`} onClick={() => this.props.go(LIVENESS_TEST)}>Start</button>
      </PageContent>
    );
  }
}

export default connect(state => state.livenessTest, { go })(PageInstructionsCLR);